import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DynIcon } from "@/components/site/DynIcon";
import { T } from "@/context/LanguageContext";

// Rotating accent colours for the compact icon chips (light, airy cards).
const ACCENTS = [
  "bg-navy/10 text-navy",
  "bg-oldglory-red/10 text-oldglory-red",
  "bg-[#0e7490]/10 text-[#0e7490]",
  "bg-[#b45309]/10 text-[#b45309]",
  "bg-navy/10 text-navy",
  "bg-oldglory-red/10 text-oldglory-red",
];

export function DiscoveryGrid({ items, onJump }) {
  if (!items || items.length === 0) return null;
  const cards = items.slice(0, 6);
  return (
    <section data-testid="discovery-grid">
      <div className="mb-4 border-b border-border pb-3">
        <h2 className="font-display text-2xl font-black tracking-tight text-navy sm:text-3xl"><T>Explore &amp; Discover</T></h2>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {cards.map((m, i) => (
          <motion.button
            key={m.key}
            onClick={() => onJump(m.tab)}
            initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.35, delay: i * 0.04 }}
            className="group flex items-start gap-3 rounded-xl border border-border bg-white p-4 text-left transition-all hover:-translate-y-0.5 hover:border-navy/30 hover:shadow-md"
            data-testid={`discovery-card-${m.key}`}
          >
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${ACCENTS[i % ACCENTS.length]}`}>
              <DynIcon name={m.icon || "compass"} className="h-5 w-5" />
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-1 font-display text-base font-bold text-navy group-hover:text-oldglory-red">
                <T>{m.label}</T>
                <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-all group-hover:opacity-100 group-hover:translate-x-0.5" />
              </span>
              {m.snippet && <span className="mt-0.5 line-clamp-2 block text-sm text-muted-foreground">{m.snippet}</span>}
            </span>
          </motion.button>
        ))}
      </div>
    </section>
  );
}
